//
// form validation for simple forms
//
// (application form validation can be found in applicationFormAchievemnts.js)
//

(function ($) {

    Drupal.behaviors.formValidation = {

        attach: function (context) {

            $(".formValidation", context).each(function (index){

                var fieldvar = window[$(this).attr("data-fieldvar")];
                var $formContainer = $(this);

                //set mandatory fields and error messages
                for (var i = 0; i < fieldvar.fields.length; i++) {
                    var field = fieldvar.fields[i];
                    var $element = $("#" + field.id);
                    var $ff = $element.closest(".formField");
                    if(field.mandatory == "true"){
                        $ff.removeClass("formField-mandatory");
                        $ff.addClass("formField-mandatory");
                    }

                    $ff.removeClass("formField-hasErrorHandling");
                    $ff.addClass("formField-hasErrorHandling");

                    $ff.find(".formField-error-message").remove();

                    for(var j=0; j < field.errors.length; j++){
                        var err = field.errors[j];
                        var $errorMessage = $("<div class='formField-error-message " + err.id + "'></div>");
                        $errorMessage.html(err.text);
                        $ff.append($errorMessage);

                        if(err.id == "length"){
                            $ff.attr("data-length", err.value);
                        }
                        else if(err.id == "equal"){
                            $ff.attr("data-equal", err.value);
                        }
                    }
                }

                //validation handling
                $(this).find("button[type='submit']").click(function(e){

                    //validate form...
                    var validationResult = Drupal.behaviors.formValidation.validateFields($formContainer, false);
                    if(validationResult){
                        //submit form...
                        return true;
                    }
                    else{
                        e.preventDefault();
                        return false;
                    }
                });
            });
        }
    };

    Drupal.behaviors.formValidation.resetUploadField = function (modal) {
        modal.find(".formField").removeClass("formField-error");
        modal.find(".formField-error-message ").hide();
        modal.find(".formField-photoLoader").attr("data-filesize", "");
        modal.find(".formField-photoLoader").attr("data-fileext", "");
        var label = modal.find(".formField-photoLoader-button-label").html();
        modal.find(".formField-photoLoader-button-label").html(label);
        modal.find(".formField-photoLoader-photo").css("background-image", "none");
        modal.find(".formField-photoLoader-button").css("width", "100%");
    }

    Drupal.behaviors.formValidation.validateEmail = function (email) {
        var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(String(email).toLowerCase());
    }

    Drupal.behaviors.formValidation.validatePassword = function (password) {
        var re = /^(?=.*[A-Z])(?=.*[a-z])(?=.*[0-9])(?=.*[!@#$%^&*()_+|~=`{}\[\]:";'<>?,.\/-]).{6,}$/;
        return re.test(String(password));
    }

    Drupal.behaviors.formValidation.validateUrl = function (url) {
        var re = /^(http:\/\/www\.|https:\/\/www\.|http:\/\/|https:\/\/)[a-z0-9]+([\-\.]{1}[a-z0-9]+)*\.[a-z]{2,5}(:[0-9]{1,5})?(\/.*)?$/;
        return re.test(String(url));
    }

    Drupal.behaviors.formValidation.validateFields = function ($container, ismodal) {

        //Drupal.behaviors.functions.consolog("Drupal.behaviors.formValidation.validateFields()");

        $(".preloader").show();


        $container.find(".formField").removeClass("formField-error");

        $container.find(".formField-error-message").hide(); //hide all error messages
        $container.find(".error-text-section").show();  //do not hide special backend errors

        var valid = true;

        $container.find(".formField-hasErrorHandling").each(function(){

            //Drupal.behaviors.functions.consolog("Drupal.behaviors.formValidation.validateFields() formField...");

            if(!$(this).is(":visible")){
                //Drupal.behaviors.functions.consolog("Drupal.behaviors.formValidation.validateFields() formField... STOP! (invisible)");
                return;
            }

            var fieldError = false;

            //do not validate form fields in modal dialogs (on main form)
            if(!ismodal && $(this).closest(".modal-dialog").length > 0){
                //Drupal.behaviors.functions.consolog("Drupal.behaviors.formValidation.validateFields() formField... STOP! (ismodal)");
                return;
            }

            if($(this).find(".formField-textField-input").length > 0){

                //text

                //show error if special backend error was found
                if($(this).find(".error-text-section").length > 0){
                    $(this).addClass("formField-error");
                    fieldError = true;
                }

                //Drupal.behaviors.functions.consolog("Drupal.behaviors.formValidation.validateFields() formField... text");
                if($(this).hasClass("formField-mandatory") && $(this).find(".formField-textField-input").val() == ""){
                    //empty textfield
                    fieldError = true;
                    $(this).find(".formField-error-message.empty").show();
                }
                else if($(this).find(".invalid-email").length > 0 && $(this).find(".formField-textField-input").val() != "" && !Drupal.behaviors.formValidation.validateEmail($(this).find(".formField-textField-input").val())){
                    //invalid-email error
                    fieldError = true;
                    $(this).find(".formField-error-message.invalid-email").show();
                }
                else if($(this).find(".invalid-url").length > 0 && $(this).find(".formField-textField-input").val() != "" && !Drupal.behaviors.formValidation.validateUrl($(this).find(".formField-textField-input").val())){
                    //invalid-url error
                    fieldError = true;
                    $(this).find(".formField-error-message.invalid-url").show();
                }
                else if($(this).find(".invalid-password").length > 0 && $(this).find(".formField-textField-input").val() != "" && !Drupal.behaviors.formValidation.validatePassword($(this).find(".formField-textField-input").val())){
                    //invalid-password error
                    fieldError = true;
                    $(this).find(".formField-error-message.invalid-password").show();
                }
                else if($(this).find(".equal").length > 0 && $("#" + $(this).attr("data-equal")).val() != $(this).find(".formField-textField-input").val()){
                    //not equal with sibling error
                    fieldError = true;
                    $(this).find(".formField-error-message.equal").show();
                }
            }
            else if($(this).find(".formField-multiTextField-input").length > 0){
                //textarea
                //Drupal.behaviors.functions.consolog("Drupal.behaviors.formValidation.validateFields() formField... textarea");
                if($(this).hasClass("formField-mandatory") && $(this).find(".formField-multiTextField-input").val() == ""){
                    //Drupal.behaviors.functions.consolog("validateFields() MULTITEXT error");
                    fieldError = true;
                    $(this).find(".formField-error-message.empty").show();
                }
            }
            else if($(this).find("select").length > 0){
                //select box
                //Drupal.behaviors.functions.consolog("Drupal.behaviors.formValidation.validateFields() formField... selectbox");
                if($(this).hasClass("formField-mandatory") && $(this).find("select").val() == ""){
                    //Drupal.behaviors.functions.consolog("validateFields() TEXT error");
                    fieldError = true;

                    $(this).find(".formField-error-message.empty").show();
                }
            }
            else if($(this).find("input[type=file]").length > 0){
                //Drupal.behaviors.functions.consolog("Drupal.behaviors.formValidation.validateFields() formField... file");
                var fileErrorVisible = 0;
                Drupal.behaviors.functions.consolog("data-max-filesize:" + $(this).find("input[type=file]").attr("data-max-filesize"));
                Drupal.behaviors.functions.consolog("data-filesize:" + $(this).find(".formField-photoLoader").attr("data-filesize"));
                Drupal.behaviors.functions.consolog("hiddenfield? " + $(this).find("input[type=hidden]").length);

                //file extention correct?!
                var extArray = $(this).find("input[type=file]").attr("accept").split(",");
                for (var i = 0; i < extArray.length; i++) {
                    const element = extArray[i];
                    extArray[i] = element.replace(" ", "").replace(".", "");
                }
                var fileExt = $(this).find(".formField-photoLoader").attr("data-fileext");
                if((!fileExt || fileExt=="")){
                    var prelImage = $(this).attr("data-preloaded-image");
                    if (typeof prelImage !== typeof undefined && prelImage !== false){
                        var filePath = $(this).find(".formField-photoLoader").attr("data-preloaded-image");
                        fileExt = filePath.split(".").pop().toLowerCase();//.substring(0,3);
                        if(fileExt.indexOf("?") >= 0){
                            fileExt = fileExt.substring(0,fileExt.indexOf("?"));
                        }
                    }
                    else{
                        fileExt = "";
                    }
                }
                Drupal.behaviors.functions.consolog("extArray:" + extArray);
                Drupal.behaviors.functions.consolog("fileExt:" + fileExt);

                if(fileExt && fileExt != "" && extArray.indexOf(fileExt) < 0){
                    fieldError = true;
                    $(this).find(".formField-error-message.filetype").show();
                    fileErrorVisible++;
                }

                //wrong filesize
                if(parseInt($(this).find(".formField-photoLoader").attr("data-filesize")) > parseInt($(this).find("input[type='file']").attr("data-max-filesize"))){

                    console.log("uploaded file: filesize error! (formvalidation.js)");

                    fieldError = true;
                    $(this).find(".formField-error-message.filesize").show();
                    fileErrorVisible++;
                }

                //file empty?!
                 if($(this).hasClass("formField-mandatory")){
                    var fieldNotFound = false;
                    var valueNotFound = false;

                    if($(this).find("input[type=hidden]").length == 0){
                        fieldNotFound = true;
                        Drupal.behaviors.functions.consolog("validateFields() FILE error // fieldNotFound A");
                    }
                    else if(typeof $(this).find("input[type=hidden]").attr("value") == typeof undefined && $(this).find("input[type=hidden]").attr("value") == false){
                        valueNotFound = true;
                        Drupal.behaviors.functions.consolog("validateFields() FILE error // fieldNotFound B");
                    }

                    if (fieldNotFound || valueNotFound) {
                        Drupal.behaviors.functions.consolog("validateFields() FILE error // fieldNotFound:" + fieldNotFound + " valueNotFound:" + valueNotFound);
                        fieldError = true;

                        if(fileErrorVisible == 0){
                            $(this).find(".formField-error-message.empty").show();
                        }

                        if($(this).find(".formField-photoLoader").length > 0){
                            //special server messages
                            $(this).find(".formField-error-message.server").remove();
                            var serverMessage = $(this).find(".formField-photoLoader").attr("data-server-message");
                            if(serverMessage != ""){
                                var errorDiv = $("<div></div>");
                                errorDiv.addClass("formField-error-message");
                                errorDiv.addClass("server");
                                errorDiv.append(serverMessage);
                                $(this).append(errorDiv);
                                errorDiv.show();
                            }
                        }
                    }
                }


            }
            else if($(this).hasClass("formField-mandatory") && $(this).find("input[type='checkbox']").length > 0){
                //checkbox
                if(!$(this).find("input[type='checkbox']").prop('checked')){
                    //Drupal.behaviors.functions.consolog("validateFields() CHECKBOX error");
                    fieldError = true;
                    $(this).find(".formField-error-message.empty").show();
                }
            }

            if(fieldError){
                $(this).addClass("formField-error");
                valid = false;
            }
        });

      if($container.find('.frc-captcha-solution')) {
        if($('.frc-captcha-solution').val() == '.UNFINISHED') {
          valid = false;
        }
      }

        Drupal.behaviors.functions.consolog("Drupal.behaviors.formValidation.validateFields() result:" + valid);

        if(!valid){
            $(".preloader").hide();
        }

        return valid;

    }

})(jQuery);
